var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTables(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 15",
    style: {
      enableBackground: "new 0 0 16 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3C363;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1533_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1534_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1535_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1536_",
    className: "st0",
    d: "M16,0.9c0-0.5-0.5-0.9-1-0.9H1C0.5,0,0.1,0.4,0,0.9h0v13c0,0.6,0.4,1,1,1h14 c0.6,0,1-0.4,1-1L16,0.9L16,0.9z M5,14H1v-3h4V14z M5,10.1H1V7h4V10.1z M5,6H1V3h4V6z M10,14H6v-3h4V14z M10,10.1H6V7h4V10.1z  M10,6H6V3h4V6z M15,14h-4v-3h4V14z M15,10.1h-4V7h4V10.1z M15,6h-4V3h4V6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTables);
export default __webpack_public_path__ + "static/media/tables.feda71394cbbaa7dfd655b6ae08ad0b3.svg";
export { ForwardRef as ReactComponent };